import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { createNote, getNotes } from "../api.js";
import { useNotification } from "contexts/NotificationContext.js";

export const useGetNotes = (page = 1, pageSize = 10, key, module, id) => {
  const { data, status, isLoading, isError, error, isSuccess } = useQuery({
    queryKey: ["notes", page, pageSize, key, module, id],
    queryFn: () => getNotes(page, pageSize, key, module, id),
    enabled: Boolean(module) && id != null && id !== "",
  });

  return {
    data,
    status,
    isLoading,
    isError,
    error,
    isSuccess,
  };
};

export const useCreateNote = () => {
  const queryClient = useQueryClient();
  const { showNotification } = useNotification();

  return useMutation({
    mutationFn: (data) => createNote(data),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ["notes"] });
      showNotification('success', 'Note created successfully!');
    },
    onError: (error) => {
      console.error("Error creating note:", error);

      // Show error notification
      let errorMessage = 'Error creating note. Please try again.';
      if (error?.response?.data?.error?.message) {
        errorMessage = error.response.data.error.message;
      } else if (error?.response?.data?.message) {
        errorMessage = error.response.data.message;
      } else if (error?.message) {
        errorMessage = error.message;
      }

      showNotification('danger', errorMessage);
    },
  });
}; 